module.exports = __webpack_public_path__ + "img/thumbnail_RedRiverHog_j_normal.73edbc48.png";